import LcwStepWrapper from './LcwStepWrapper.component';

export default LcwStepWrapper;